import { axiosInstance } from '@/api/axiosInstance';
import { IUnitModel } from './unitModels';

export default async function apiUnitUpdate(unit: IUnitModel): Promise<IUnitModel> {
    return await axiosInstance.put('/v1/units/', unit);
}